import { memo } from 'react';
import moment from 'moment';
import ServicesToDeliverReportContent from '../../pages/Reports/ServicesToDeliverReport/ServicesToDeliverReportContent';

export default memo(function ServicesToDeliverByDateReport({
  date = '',
  close: _close = () => {},
  storeId = 'all',
  companyId = ''
}: {
  date: string;
  close: () => void;
  storeId: string;
  companyId: string;
}) {
  const initialDate = date ? moment(date).toDate() : moment().toDate();

  return (
    <ServicesToDeliverReportContent
      companyId={companyId}
      storeId={storeId}
      showStoreSelect
      initialDateRange={[initialDate, initialDate]}
    />
  );
});
